import regionalPagesJSON from './json/regional-pages.json'

export const regionalPages = regionalPagesJSON
